module.exports = __webpack_public_path__ + "media/src/images/balloons/balloons_blur-6303b20a2507c9a623a834ae295f68c3.png";